import React, { createContext, useContext, useState, useEffect } from 'react';
import store from '../stores/redux';
import UserStore from '../stores/UserStore';
import Locales from '../locales';

export const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
    const [translations, setTranslations] = useState(() => {
        try {
            return UserStore.getTranslation() || {};
        } catch (error) {
            console.warn('Failed to get translations from UserStore:', error);
            return {};
        }
    });

    useEffect(() => {
        const unsubscribe = store.subscribe(() => {
            try {
                const newTranslations = UserStore.getTranslation() || {};
                setTranslations(newTranslations);
            } catch (error) {
                console.warn('Failed to update translations:', error);
            }
        });

        return unsubscribe;
    }, []);

    return (
        <TranslationContext.Provider value={translations}>
            {children}
        </TranslationContext.Provider>
    );
};

// Legacy provider to support class components expecting context.t
export class LegacyTranslationProvider extends React.Component {
    getChildContext() {
        try {
            return { t: UserStore.getTranslation() || {} };
        } catch (e) {
            return { t: {} };
        }
    }

    render() {
        return this.props.children || null;
    }
}

LegacyTranslationProvider.childContextTypes = {
    t: () => null
};

export const useTranslation = () => {
    const context = useContext(TranslationContext);
    if (context === undefined) {
        console.warn('useTranslation must be used within a TranslationProvider');
        return {};
    }
    return context;
};

export const withTranslation = (WrappedComponent) => {
    if (!WrappedComponent) {
        console.warn('withTranslation: WrappedComponent is undefined');
        return () => null;
    }

    const WithTranslationComponent = (props) => {
        try {
            const translations = useTranslation();
            return <WrappedComponent {...props} t={translations} />;
        } catch (error) {
            console.warn('withTranslation error:', error);
            return <WrappedComponent {...props} t={{}} />;
        }
    };

    WithTranslationComponent.displayName = `withTranslation(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return WithTranslationComponent;
};

export default {
    TranslationProvider,
    LegacyTranslationProvider,
    useTranslation,
    withTranslation
};
